(function () {
  'use strict';

  /* @ngdoc object
   * @name flightInformationReport
   * @description
   *
   */
  angular
    .module('flightInformationReport', [
      'ui.router'
    ]);
}());
